module.exports = __webpack_public_path__ + "img/pic_button_start_active_en@2x.5c38d6d0.png";